import React from 'react';

const MainPanel = ({ children }) => {
  return <div className="main-panel">{children}</div>;
};

export default MainPanel;
